import { render, staticRenderFns } from "./BookableAddonsTab.vue?vue&type=template&id=e6826b14"
import script from "./BookableAddonsTab.vue?vue&type=script&lang=js"
export * from "./BookableAddonsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports